/// <amd-module name="VSS/Ext/Components/ExternalContent/ExternalContent" />
import * as React from "react";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getContributionContentProps } from "../../ExternalContentUtil";

import { IExternalContentInteractionProvider, IExternalContentProps } from "./ExternalContent.Props";
import { ExternalContentBase } from "./ExternalContentBase";
import { SdkInteractionProvider } from "./SdkInteractionProvider";

interface IExternalContentState {
    url?: string;
    interactive?: boolean;
}

export class ExternalContent extends VssComponent<IExternalContentProps, IExternalContentState> {
    public constructor(props: IExternalContentProps, context?: IVssComponentContext) {
        super(props, context);

        this.state = {};
    }

    public render(): JSX.Element {
        const { backgroundHost, contributionId, initialHandshakeData, resizeOptions } = this.props;
        const { url, interactive } = this.state;

        let getInteractionProvider: { (iframe: HTMLIFrameElement): IExternalContentInteractionProvider } | undefined;

        if (url && interactive) {
            getInteractionProvider = (iframe: HTMLIFrameElement) => {
                return new SdkInteractionProvider(
                    this.context.pageContext,
                    iframe,
                    contributionId,
                    initialHandshakeData,
                    resizeOptions,
                    backgroundHost
                );
            };
        }

        return url ? <ExternalContentBase {...this.props} url={url} getInteractionProvider={getInteractionProvider} /> : <div />;
    }

    public componentDidMount() {
        super.componentDidMount();

        this.updateContentProperties();
    }

    public componentDidUpdate(prevProps: IExternalContentProps, prevState: IExternalContentState) {
        super.componentDidUpdate(prevProps, prevState);

        if (this.props.contributionId !== prevProps.contributionId) {
            this.updateContentProperties();
        }
    }

    private updateContentProperties() {
        this.trackPromise(
            getContributionContentProps(
                this.context.pageContext,
                this.props.contributionId,
                this.props.initialHandshakeData,
                this.props.contributionUri
            )
        ).promise.then(contentProps => {
            this.setState({
                url: contentProps ? contentProps.url : undefined,
                interactive: contentProps && contentProps.interactive
            });
        });
    }
}

Components.add("ExternalContent", ExternalContent);
